import AppLoader from 'Components/AppLoader';
import { useUserEffect } from 'Components/Authorize/guardHelpers';
import { connect } from 'react-redux';

import { getRedirectURLLocalStorage, loadPage } from '../../../helpers';

const GuestOnlyGuard = ({ redirectRoute, user, fallback, children, path, url, overrideHistory }) => {
  useUserEffect();
  if (user?.logged) {
    if (fallback) {
      return fallback;
    }
    const newPath = getRedirectURLLocalStorage();
    const { search } = window.location;
    const redirectRouteWithSearchParams =
      ['/map', '/home'].includes(redirectRoute) && search ? `${redirectRoute}${search}` : redirectRoute;
    let finalUrl = url.replace(
      path,
      overrideHistory ? redirectRouteWithSearchParams : newPath ?? redirectRouteWithSearchParams,
    );
    const queryParts = finalUrl.split('?');
    if (queryParts.length > 2) {
      finalUrl = `${queryParts[0]}?${queryParts.slice(1).join('&')}`;
    }
    // here we use loadPage(window.open or window.location) instead of route
    // is due that the main routes don't exist in the public routing pages
    loadPage(finalUrl);
  }

  if (user?.sessionChecked) {
    return children;
  }

  return <AppLoader />;
};

export default connect(({ user }) => ({ user }))(GuestOnlyGuard);
